/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function BrowserMobileBlocker(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'BrowserMobileBlocker',
      'aria-hidden': true,
      focusable: false,
      width:  62 * scale,
      height: 44 * scale,
      viewBox: '0 0 62 44',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"fill":"none","stroke":"currentColor","strokeWidth":"2","strokeMiterlimit":"10","d":"m23.6 13.1 5 5-5 4.9"}),createElement('path', {"fill":"currentColor","d":"M59 0H13c-1.7 0-3 1.3-3 3v14H3c-1.7 0-3 1.3-3 3v21c0 1.7 1.3 3 3 3h11c1.7 0 3-1.3 3-3v-5h13.8c-.1.5-.2 1.1-.4 1.7-.2.9-.6 1.8-1.1 2.5-.4.7-1 1.3-1.7 1.8H25v2h22v-2h-2.7c-.7-.5-1.3-1.2-1.8-2-.8-1.3-1.2-2.8-1.4-4H59c1.7 0 3-1.3 3-3V3c0-1.7-1.3-3-3-3M15 41c0 .5-.5 1-1 1H3c-.5 0-1-.5-1-1V20c0-.5.5-1 1-1h11c.5 0 1 .5 1 1zm26.5 1h-11c.2-.3.5-.6.7-1 .9-1.6 1.4-3.3 1.6-4.7 0-.1 0-.2.1-.4h6.3c.1.5.2 1.2.4 1.8.3 1 .7 2.2 1.3 3.2.1.5.3.8.6 1.1M60 33c0 .5-.5 1-1 1H17V20c0-.4-.1-.7-.2-1H29v-2H12V3c0-.5.5-1 1-1h46c.5 0 1 .5 1 1zM8.5 36c-.8 0-1.5.7-1.5 1.5S7.7 39 8.5 39s1.5-.7 1.5-1.5S9.3 36 8.5 36"}))
}
